$(function() {
  const BaseModule = require('_base/base')
  const { hasOnlyText } = require('../../helpers/nodeUtils')

  const CLASS_CUTTEDOFF = 'is__cuttedOff'
  const CLASSES_TEXT_ONLY = '.is__textOnly, .is__onlyText'

  const sumOfHeights = $els => $els.get().reduce((sum, el) => sum += $(el)[0].scrollHeight, 0)

  class FitToContentSwitcher extends BaseModule {
    postInit() {
      this.$spread = this.spread.$el
      this.$page = this.$el.closest('.js__page')
      this.$children = this.$el.children()

      this.preReset()
    }

    preReset() {
      this.$children.css({
        bottom: 'auto',
        '--moduleTransformY': '',
      })
      this.$spread.removeClass(CLASS_CUTTEDOFF)
    }

    get shouldRecalculate() {
      // HACK: otherwise nested liftouts and MO (both affecting height) initialize before FTCS
      // which results in wrong FTCS height
      return this.$el.closest('.is__mobileOverhead').length
    }

    calculateMaxHeight() {
      this.maxHeight = 0

      this.$children.each((_, el) => {
        var childHeight = $(el).height()

        if (this.maxHeight < childHeight) {
          this.maxHeight = childHeight
        }
      })
    }

    checkSwitcherItemsOverflow() {
      this.$children.each((_, el) => {
        const $switcherItem = $(el)
        const $children = $switcherItem.children()
        const onlyText = $switcherItem.is(CLASSES_TEXT_ONLY) || hasOnlyText($switcherItem)

        if (!onlyText) return

        const switcherItemHeight = $switcherItem.height()
        const childrenHeight = sumOfHeights($children)
        const safePageBottomPadding = parseInt(this.$page.css('padding-bottom'), 10)

        const isOverflown = (switcherItemHeight + safePageBottomPadding) < childrenHeight

        if (isOverflown) {
          const requiredShift = childrenHeight - switcherItemHeight

          $switcherItem[0].style.setProperty('--moduleTransformY', '-' + requiredShift + 'px')
          this.$spread.addClass(CLASS_CUTTEDOFF)
        }
      })
    }

    postCalculate() {
      this.calculateMaxHeight()
    }

    postRender() {
      if (this.shouldRecalculate) this.calculateMaxHeight()

      this.$el.css({
        'flex-basis': this.maxHeight + 'px',
        'max-height': this.maxHeight + 'px',
      })

      this.$children.css({ bottom: 0 })
      this.checkSwitcherItemsOverflow()
    }
  }

  $('.switcher.is__fitToContent').each(function() {
    new FitToContentSwitcher($(this))
  })
})
